import { SELECT_OPEN_OPERATIONS } from '../constants/operation-analysis';

const operationAnalysis = {
  openOperations: [],
};

export default (state = operationAnalysis, action) => {
  switch (action.type) {
    case SELECT_OPEN_OPERATIONS:
      return {
        ...state,
        openOperations: action.operations,
      };
    default:
      return state;
  }
};
